import { StatusMessage } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import { Wrench } from 'lucide-react';

/**
 * Placeholder for an Instance Detail tab; each tab story (CT-4189…4194) replaces
 * its element. `comingSoon` swaps the ticket line for a plain coming-soon note —
 * used for the Usage tab, which is a V1 extra with no prototype counterpart.
 */
const InstanceTabPlaceholder = ({ labelKey, ticket, comingSoon = false }) => {
  const { t } = useTranslation('admin-studio');
  return (
    <StatusMessage
      icon={Wrench}
      title={t(labelKey)}
      subtitle={
        comingSoon
          ? t('integrations.instance.comingSoon')
          : t('integrations.provider.tabPlaceholder', { ticket })
      }
    />
  );
};

export default InstanceTabPlaceholder;
